import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
  },

  warpper: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "row",
    width: "100%",
    padding: 0,
    paddingTop: 10,
  },

  filterSector: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    flexShrink: 0,
    gap: 12,
    marginTop: 4,
    marginBottom: 8,
  },

  line: {
    width: "100%",
    margin: 0,
    border: 0,
    borderTop: "1px solid #C1C1C5",
    flexShrink: 0,
  },

  placeHolder: {
    color: '#000000',
    fontSize: 12,
  },

  label: {
    color: '#fff',
    marginBottom: 5,
    fontSize: 14,
    fontWeight: 'bold',
  },
  filterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 20,
    marginTop: 40,
    gap: 10,
    width: '100%',
    marginBottom: 20,
    alignItems: "center"
  },
}));

export default useStyles;
